import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';
import { Motivo } from '../models/';

@Injectable()
export class MotivosService extends RESTService<any> {

  public motivo: Motivo;
  public motivos: Motivo[];

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/resumenPaciente',
    });
  }

  /**
   * obtenerMotivos: obtiene el listado completo de Motivos de un paciente
   * @param pacienteId: string
   * @return any
   */
  obtenerMotivos(pacienteId: string, visita: string): any {
    return this._http.post(environment.api_host + 'motivosConsulta/obtenerMotivosConsulta', {
      numeroExpediente: pacienteId,
      visita: visita,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  /**
   * guardarMotivo
   * @param params: object
   * @return boolean
   */
  guardarMotivo(params: any): Observable<string> {
    return this._http.post(environment.api_host + 'motivosConsulta/guardarMotivo', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.resultado !== undefined) {
        return respuesta.resultado;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }
}



// WEBPACK FOOTER //
// ./src/services/motivos.service.ts